import { useEffect } from 'react';

/**
 * Closes an open dropdown/panel on an outside click. Matches this app's
 * existing pattern (App.jsx) of checking `event.target.closest(selector)`
 * against the dropdown's own container class, rather than a ref — so this
 * takes a CSS selector, not a ref, to stay a pure move of the existing
 * effects rather than a behavior change.
 *
 * @param {boolean} isOpen - whether the dropdown/panel is currently open
 * @param {string} selector - CSS selector for the dropdown's own container;
 *   a click inside it does not count as "outside"
 * @param {() => void} onClose - called when a genuine outside click occurs
 */
export function useOutsideClick(isOpen, selector, onClose) {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest(selector)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, selector]);
}
